import { makeStyles } from "@material-ui/core";

import type { CoretexTheme } from "../../theme";

const useStyles = makeStyles((theme: CoretexTheme) => ({
  root: {
    backgroundColor: theme.palette.mono.white,
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    padding: theme.spacing(2),
    gap: theme.spacing(1),
  },
  icon: {
    flex: 0,
    maxWidth: "15%",
  },
  primary: {
    display: "flex",
    width: "100%",
    height: "16px",
    lineHeight: "16px",
    flexDirection: "row",
    alignItems: "flex-start",
    justifyContent: "space-between",
  },
  primaryLeftSide: {
    display: "flex",
    flexDirection: "row",
    gap: theme.spacing(1),
  },
  primaryRightSide: {
    display: "flex",
    flexDirection: "row",
    gap: theme.spacing(2),
  },
  subtitles: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    maxWidth: "80%",
  },
  subtitleFont: {
    fontWeight: 400,
    fontSize: 12,
    color: theme.palette.mono.secondaryDark,
    marginRight: 4,
    lineHeight: "16px",
  },
  secondary: {
    flex: 1,
    alignItems: "center",
    height: "16px",
    lineHeight: "16px",
  },
  tertiary: {
    flex: 1,
    alignItems: "center",
    height: "16px",
    lineHeight: "16px",
  },
  footer: {
    width: "100%",
  },
}));

export { useStyles };
